import i18n from '@/i18n'

const imgHost = (process.env.VUE_APP_BASE_API || '/api') + '/front/articleInfo/downloadArticle?resource='

/**
 * 传入图片地址，转成带地址参数的url
 */
export const getImage = (val) => {
  if (!val) return ''
  return `${imgHost}${encodeURIComponent(val)}`
  // return val.replace(/\/profile\//g, process.env.VUE_APP_PROFILE)
}

/**
 * 根据 authorList 拼接作者展示字符串：
 * - 多位：用顿号拼接并在末尾追加 " 编"
 * - 单位：直接返回名字
 * - 空列表：回退到 fallback（通常传入 item.authorName）
 */
export const formatAuthorName = (authorList, fallback = '') => {
  const names = Array.isArray(authorList)
    ? authorList.map((a) => a && a.authorName).filter(Boolean)
    : []
  const suffix = names.length > 1 ? i18n.t('bookDetail.editorPlural') : i18n.t('bookDetail.editorSingle')
  if (names.length > 1) return names.join('、') + suffix
  if (names.length === 1) return names[0] + suffix
  return fallback || ''
}